import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@ublend-npm/aulaui-next';

import { studentGradesType } from '../../types';

import {
  Name,
  Email,
  Info,
  Container,
  Separator,
} from './StudentInfoColumn.styled';

const StudentInfoColumn = ({ studentGrades }) =>
  studentGrades.map(({ firstName, lastName, email, avatar, studentId }) => (
    <Fragment key={studentId}>
      <Container>
        <Avatar size="large" name={`${firstName} ${lastName}`} src={avatar} />
        <Info>
          <Name>{`${firstName} ${lastName}`}</Name>
          <Email>{email}</Email>
        </Info>
      </Container>
      <Separator />
    </Fragment>
  ));

StudentInfoColumn.propTypes = {
  studentGrades: PropTypes.arrayOf(studentGradesType).isRequired,
};

export default StudentInfoColumn;
